import { useEffect, useState } from "react";
import { MainPageBase } from "../page-bases/MainPageBase";
import { NoItemContent } from "../page-bases/NoItemContent";
import { Box, Stack } from "@mui/material";
import { useParams } from "react-router-dom";

import { TRowItem } from "../../components/Table/TableRow";
import { useMangeTableItems } from "../../hooks/useManageTableItems";
import { usePagination } from "../../hooks/usePagination";
import { assetBatchDistributionApi } from "../../services/distribution/asset-distribution";
import { actionDialogStore, alertDialogStore } from "../../store/dialogs";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { SimpleLabel } from "../../components/Label/SimpleLabel";
import { updateBatchDistributionCart } from "../../store/reducers/distribution/distributedRecordStore";
import { AssetLogsFilter } from "../../common-ui/page-filters";
import { IAssetRecord, IPagination, IQueryPerams } from "../../config/types";
import { formatDate } from "../../utils/common";
import DamsTable from "../../components/Table/CollapsibleTable";
import LabelButton from "../../components/Button/LabelButton";
import useAppNavigation from "../../hooks/useAppNavigation";
import appRoutePath from "../../config/path";

function InBoundDistributionDetailPage() {
  const [pageState, setPageState] = useState<string>("main");
  const [dataset, setDataset] = useState<TRowItem[]>([]);
  const { id } = useParams<{ id: string }>();
  const entryDetail = useAppSelector((data) => data.batchDistributionCart);
  const fetchAssetsFromDistribution=()=> assetBatchDistributionApi.getAssetFromDistribution(
    id ?? ""
  )
  const {
    pagination,
    paginateToNextPage,
    paginateToPreviousPage,
    paginateToPageNumber,
    updatePaginationInitState,
  } = usePagination<any>(fetchAssetsFromDistribution);
  const dispatch = useAppDispatch();
  const { selectedRowItems, toggleRow, toggleSelectAllRow } =
    useMangeTableItems(dataset);

  const [querySet, setQuerySet] = useState<IQueryPerams>({ is_deleted: false });
  const populateDataSet = (data: IAssetRecord[], pagination?: IPagination) => {
    const formatData = data.map((data) => ({
      ...data,
      date_received: formatDate(data.date_received),
      asset_meta_raw: data.asset_meta
        ? data.asset_meta.map(
            (item) => ` ${item.asset_tag}=${item.meta_value} `
          )
        : [],
    }));

    setDataset(formatData);
    updatePaginationInitState(pagination);
  };

  const fetchData = async () => {
    const result = await assetBatchDistributionApi.getAssetFromDistribution(
      id ?? ""
    );
    if (result?.data) {
      populateDataSet(result.data, result.pagination);
    }
    const distributionDetail =
      await assetBatchDistributionApi.getBatchDistribution(id ?? "");
    if (distributionDetail.data) {
      dispatch(updateBatchDistributionCart(distributionDetail.data));
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const account=useAppSelector((data)=>data.authVerify);
  
  const navigate = useAppNavigation();
  function addNewItem() {}

  function clearSearch() {
    setPageState("empty-db");
  }



  function handleDelete(item: TRowItem) {
    actionDialogStore.open({
      title: "Remove Asset",
      subtitle: `${item.brand} ,model ${item.model} ,Are you sure you want to remove asset from this distribution ?`,
      onRightBtnPress: async () => deleteRequest(item.id),
    });
  }
  async function deleteRequest(asset_id: string) {
    const res = await assetBatchDistributionApi.removeAssetFromDistribution(
      id ?? "",
      asset_id
    );
    if (res.success) {
      fetchData();
    }
    alertDialogStore.open({
      title: res.success ? "Remove Asset" : "Remove Asset Failed",
      subtitle: res.message,
      isSuccess: res.success,
    });
  }

  if (!entryDetail.id) {
    return null;
  }

  const canModify=account.domain_id===entryDetail.from_location_id;

  return (
    <MainPageBase
      pageState={"main"}
      title={`Distribution Information`}
      extraComponent={
        <LabelButton
          onPress={() =>{
             navigate({ path: appRoutePath.INBOUND_ASSET_DISTRIBUTIONS_PAGE })
          }
           
          }
          label={"Back"}
          direction={"left"}
        />
      }
    >
      <Box
        height={`100%`}
        display={"flex"}
        alignItems={pageState !== "main" ? "center" : ""}
        justifyContent={"center"}
      >
        {pageState !== "main" ? (
          <NoItemContent
            type={pageState}
            title={""}
            subtitle={""}
            addItemBtn={() => addNewItem()}
            clearSearchBtn={() => clearSearch()}
          />
        ) : (
          <Stack width={"100%"}>
            <Stack spacing={1.5} marginBottom={2} direction={"column"}>
              <SimpleLabel title="Departure Details" />
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel title="Departure domain" fontWeight={400} />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.from_location_domain}
                  width={"100%"}
                />
              </Stack>
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel
                  title="Departure domain location"
                  fontWeight={400}
                />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.from_location}
                  width={"100%"}
                />
              </Stack>
              <SimpleLabel title="Recipent Details" />
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel title="Recipent domain" fontWeight={400} />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.to_location_domain}
                  width={"100%"}
                />
              </Stack>
              <Stack direction={"row"} width={"100%"}>
                <SimpleLabel
                  title="Recipent domain distination"
                  fontWeight={400}
                />
                <SimpleLabel
                  fontWeight={700}
                  title={entryDetail.to_location}
                  width={"100%"}
                />
              </Stack>
            </Stack>

            <AssetLogsFilter<IAssetRecord[]>
              ftn={fetchAssetsFromDistribution}
              updateDataSet={populateDataSet}
              updateQuerySet={setQuerySet}
              isAssigned={false}
              isDeleted={false}
            />

            <DamsTable
              tableTitle={"Distribution Assets"}
              tableSubtitle={""}
              tableTitleBadge={
                selectedRowItems.length === 0
                  ? ""
                  : ` ${selectedRowItems.length} selected`
              }
              tableHeaders={columns}
              hiddenKeys={hkeys}
              hiddenLabels={hcolumns}
              data={dataset}
              tableKeys={tkeys}
              useTableCheckbox={true}
              selectedRowItems={selectedRowItems}
              onTableItemSelect={toggleRow}
              toggleSelectAllRow={toggleSelectAllRow}
              onTableItemDelete={ canModify?handleDelete:undefined}
              hasPagination
              paginationState={pagination}
              onNextPage={paginateToNextPage(querySet, populateDataSet)}
              onPreviousPage={paginateToPreviousPage(querySet, populateDataSet)}
              setActivePage={paginateToPageNumber(populateDataSet, querySet)}
            />
          </Stack>
        )}
      </Box>
    </MainPageBase>
  );
}

const tkeys = [
    "asset_category_name",
    "serial_number",
    "brand",
    "embossment_number",
    "assigned",
    "date_received"
  ];
  
  const columns = [
    "Asset Category",
    "Serial Number",
    "Brand",
    "Embossment Number",
    "Assigned",
    "Date Received"
  ];
  const hkeys = ["warranty_in_months", "asset_meta_raw"];
  
  const hcolumns = ["Warranty (months)", "Additional Information"];
  
export { InBoundDistributionDetailPage };
